import { useState } from 'react';
import { cn } from '../lib/cn';

const sizes = {
  xs: 'size-[18px] text-[9px]',
  sm: 'size-5 text-[9px]',
  md: 'size-6 text-[10px]',
  lg: 'size-8 text-xs',
  xl: 'size-16 text-lg',
};

export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '';
  return (first + last).toUpperCase();
}

/**
 * Foto de perfil quando houver; senão (ou se a imagem falhar) iniciais em mono sobre fundo
 * neutro. Um só fundo, sem cores aleatórias.
 */
export function Avatar({
  name,
  src,
  size = 'sm',
  className,
}: {
  name: string;
  src?: string | null;
  size?: keyof typeof sizes;
  className?: string;
}) {
  const [failed, setFailed] = useState<string | null>(null);
  const showImage = Boolean(src) && failed !== src;
  return (
    <span
      title={name}
      className={cn(
        'inline-grid shrink-0 place-items-center overflow-hidden rounded-full border border-border bg-surface-3 font-mono text-text-2',
        sizes[size],
        className,
      )}
    >
      {showImage ? (
        <img
          src={src!}
          alt={name}
          className="size-full object-cover"
          onError={() => setFailed(src ?? null)}
        />
      ) : (
        initialsOf(name)
      )}
    </span>
  );
}
